import RequestSuccessModal from './RequestSuccessModal'

export default RequestSuccessModal
